import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";
import { generateParamsFromObj } from "@/common/utils";

const getQuoteById = async (
  id: string,
  filters: any,
  skip: string,
  searchQ: string
) => {
  const params = generateParamsFromObj(filters);
  const searchFields = [
    "lastMileProvider",
    "manufaturerName",
    "provider",
    "productCode",
  ];
  params.append("take", "10");
  params.append("skip", skip);
  searchFields.forEach((el) => params.append("searchFields", el));
  params.append("searchQ", searchQ);
  return await axiosInstance
    .get(`req/quotes/single/results/${id}`, { params })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useGetQuoteById = (
  id: string,
  filters: any,
  searchQ: string,
  skip: number
) => {
  return useQuery({
    queryKey: ["quoteReq", id, filters, skip, searchQ],
    queryFn: () => getQuoteById(id, filters, skip.toString(), searchQ),
    enabled: id !== "0",
  });
};

export default useGetQuoteById;
